import React from 'react';

const FupOutputIcon: React.FC<{ width?: number; height?: number }> = ({ width = 48, height = 48 }) => (
  <svg width={width} height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="6" width="36" height="36" rx="6" ry="6" fill="#ffffff" stroke="#0D3559" strokeWidth="2" />
    <circle cx="6" cy="24" r="4" fill="#ffffff" stroke="#B2140F" strokeWidth="2" />
    <text x="28" y="29" textAnchor="middle" fontFamily="Inter, Arial" fontSize="14" fill="#0D3559" fontWeight="700">OUT</text>
  </svg>
);

export default FupOutputIcon;
